import React from 'react';
import t from '@jetshop/intl';
import NavigationItems from '../NavigationItems';
import { Above } from '@jetshop/ui/Breakpoints';

const ChildrenCategories = ({ category }) => {
  const hasNoParent = category?.parent === null;
  return category?.subcategories?.length > 0 ? (
    <>
      <div>
        {!hasNoParent && (
          <h2>
            {t('Everything in')}
            {category.name}
          </h2>
        )}

        <Above breakpoint="md">
          {matches =>
            matches ? (
              <NavigationItems
                categories={category.subcategories}
                categoryId={category.id}
              />
            ) : (
              <>
                <NavigationItems
                  categories={category.subcategories}
                  categoryId={category.id}
                />
              </>
            )
          }
        </Above>
      </div>
    </>
  ) : null;
};

export default ChildrenCategories;
